import { render, staticRenderFns } from "./wzList.vue?vue&type=template&id=03f5956d&scoped=true&"
import script from "./wzList.vue?vue&type=script&lang=js&"
export * from "./wzList.vue?vue&type=script&lang=js&"
import style0 from "./wzList.vue?vue&type=style&index=0&id=03f5956d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f5956d",
  null
  
)

export default component.exports